import app from '../app.first';

app.CreateInterview = class extends app.Component {
	onReady() {
		this.$el.find('input').on('change keyup blur', e => {
			this.computeRemainingSmsChars();
		});
		this.computeRemainingSmsChars();

		this.$el.find('input').on('focus keyup change', e => {
			const $target = $(e.target);
			$target.prop('maxlength', this.computeRemainingSmsChars() + $target.val().length);
		});

		this.$el.find('[data-source]').on('change keyup blur', e => {
			let $target = this.$el.find(`[data-target="${e.target.dataset.source}"]`);
			$target.text(e.target.value || $target.data('default'));
		});
	}

	computeRemainingSmsChars() {
		const $remainingSpan = this.$el.find('[data-sms-remaining-chars]');

		const length = this.$el.find('[data-sms-container]').text().replace(/(\s)+/g, "$1").length;
		const remaining = $remainingSpan.data('limit') - length;
		$remainingSpan.text(remaining);

		return remaining;
	}
}